import React from 'react'
import './style.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const NavbarNew = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  return (
    <>
      <div className='new_navbar_wrapper'>
        <div className='new_navbar_body_div'>
          <div className='left_side_div'>
            <div className='navbar_logo_div'>
              <img className='img-fluid' src={'/images/maayot-green-logo-small.svg'} alt={t('nav.logoAlt')} />
            </div>
          </div>
          <div className='right_side_div'>
            <button
              className='common-btn-cls green-btn-class input-btn mt-0 header_btn_cls'
              onClick={() => navigate('/learn-chinese/new')}
            >
              {t('nav.signUp')}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default NavbarNew
